<template>
	<div class="twitter-share-link">
		<a :href="link" title="Twitter" data-share="twitter"><i class="fa fa-twitter" @click="share(link)"></i></a>
	</div>
</template>

<script type="text/javascript">
export default{
	name: 'TwitterShare',
	props: ['href'],
	data: function(){
		return {
			link: 'http://twitter.com/share?url='+this.href
		}
	},
	methods: {
		share : function(link){
			var left = (screen.width - 280) /2;
			var top = (screen.height - 280) /2;
			var fbWindow = window.open(link, '', 'width=280,height=280,left='+left+',top='+top)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/share/TwitterShare.vue